import { render, staticRenderFns } from "./TrainAdd.vue?vue&type=template&id=820cc86c&scoped=true"
import script from "./TrainAdd.vue?vue&type=script&lang=js"
export * from "./TrainAdd.vue?vue&type=script&lang=js"
import style0 from "./TrainAdd.vue?vue&type=style&index=0&id=820cc86c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820cc86c",
  null
  
)

export default component.exports